const radii = {
  sm: "4px",
  md: "6px",
  base: "6px",
  lg: "8px",
  xl: "12px",
  "2xl": "16px",
  full: "9999px",
};

export default radii;
